import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import { headerHeight } from '~/utilities';

export const CommodityInfoTabStyled = styled(Box).attrs({
  flexGrow: { sm: 1 },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  pr: { sm: '400' },
})`
  background-color: ${({ theme }) => theme.colors.grey[100]};
  width: 100%;
  height: ${headerHeight}px;
`;

export const ContentContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  height: calc(100% - ${headerHeight}px);
  width: 100%;
  overflow-y: auto;
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: 28px;
  height: 28px;
  min-width: 28px;
  border: none;
  position: relative;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.primary[700]};
    border-radius: ${theme.spacings[200]};
    padding: ${theme.spacings[300]};
    &:focus {
      background-color: ${theme.colors.white};
      box-shadow: none;
    }
    &:hover {
      background-color: ${theme.colors.white};
      box-shadow: none;
    }
  `};
  ${({ theme, selected }) =>
    selected &&
    css`
      font-weight: ${theme.fontWeights[600]};
      background-color: ${theme.colors.primary[700]};
      color: ${theme.colors.white};
      &:hover {
        background-color: ${theme.colors.primary[700]};
        box-shadow: none;
      }
      &:focus {
        background-color: ${theme.colors.primary[700]};
        box-shadow: none;
      }
    `};
`;
